module.exports = __webpack_public_path__ + "img/img46.b4c47136.svg";